/* eslint-disable react/no-unused-state */
/* eslint-disable react/no-unescaped-entities */
import React, { Component } from 'react';
import ActivityIndicator from '@lyearn-team/frontend-components/dist/Loader';
import DarkBoxInput from '@lyearn-team/frontend-components/dist/Input/DarkBoxInput';
import Icon from '@lyearn-team/frontend-components/dist/Icon';
import globalURL from 'helper/url';
import theme from '@lyearn-team/theme-config';
import DarkButton from '@lyearn-team/frontend-components/dist/Button/DarkButton';
import {
  buttonClass,
  IconWrapper,
  BackToSignInWrapper,
  GreyWrapper,
  ResponseStatusText,
  ResponseStatusInstructions,
  content,
  troubleLoginEmail,
  inputClass,
  ContactLyearnText,
  troubleLoginForm
} from './styles';
import { validateEmail } from '../shared/static';
import { EmailStatus } from '../shared/consts';
import { LoginContent, LoginNormalText, LoginContentHeading } from '../styles';

const troubleShootUserTypes = {
  FORGOT_PASSWORD: 'FORGOT_PASSWORD',
  USER_INVITATION: 'USER_INVITATION',
  USER_NOT_EXISTS: 'USER_NOT_EXISTS',
  OTHER: 'OTHER'
};

class DarkTroubleLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      emailAddress: '',
      emailErrorStatus: '',
      responseStatus: '',
      fromEmail: '',
      loading: false,
      success: false
    };
  }

  onEmailAddressChange = e => {
    if (e.target.value && this.state.emailErrorStatus) {
      this.setState({
        emailErrorStatus: '',
        responseStatus: ''
      });
    }
    this.setState({ emailAddress: e.target.value });
  };

  send = (params, requestURL) => {
    fetch(requestURL, {
      method: 'POST',
      headers: {
        accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: params
    })
      .then(response => response.json())
      .then(response => {
        // const response = {
        //   sentEmailType: troubleShootUserTypes.FORGOT_PASSWORD,
        //   fromAddress: 'priyesh.patel@lyearn.com'
        // };
        this.setState({ loading: false });
        if (!response.error) {
          if (response.sentEmailType === troubleShootUserTypes.FORGOT_PASSWORD) {
            this.setState({
              responseStatus: troubleShootUserTypes.FORGOT_PASSWORD,
              fromEmail: response.fromAddress
            });
          }
          if (response.sentEmailType === troubleShootUserTypes.USER_INVITATION) {
            this.setState({
              responseStatus: troubleShootUserTypes.USER_INVITATION,
              fromEmail: response.fromAddress
            });
          }
        } else if (response.message === troubleShootUserTypes.USER_NOT_EXISTS) {
          this.setState({ emailErrorStatus: troubleShootUserTypes.USER_NOT_EXISTS });
        } else {
          this.setState({ emailErrorStatus: troubleShootUserTypes.OTHER });
        }
      })
      .catch(error => {
        console.log('Error is', error);
        this.setState({ loading: false, emailErrorStatus: troubleShootUserTypes.OTHER });
      });
  };

  sendEmail = event => {
    event.preventDefault();
    const email = this.state.emailAddress;
    const { companySubDomain } = this.props;
    let params = '';
    let requestURL = '';
    if (!email) {
      this.setState({ emailErrorStatus: EmailStatus.BLANK_EMAIL });
      return;
    }
    if (!validateEmail(email)) {
      this.setState({ emailErrorStatus: EmailStatus.EMAIL_NOT_VALID });
      return;
    }
    this.setState({ loading: true });
    params = JSON.stringify({
      subDomain: window.location.host.split('.')[0],
      uniqueId: this.state.emailAddress.toLowerCase()
    });
    requestURL = globalURL.awsEndpoint + `/troubleshootUser?cn=${companySubDomain}`;
    this.send(params, requestURL);
  };

  renderActivityIndicator = () => (
    <ActivityIndicator
      svgColor="#fff"
      style={{ marginRight: '6px', fill: '#fff' }}
      width={16}
      height={16}
    />
  );

  backToSignIn = () => {
    this.setState({ emailErrorStatus: '', responseStatus: '' });
  };

  sendEmailClicked = () => {};

  renderContent = () => {
    const { emailAddress, responseStatus, fromEmail, loading } = this.state;
    let icon = '';

    if (loading) {
      icon = this.renderActivityIndicator();
    }
    if (responseStatus === troubleShootUserTypes.FORGOT_PASSWORD) {
      return (
        <React.Fragment>
          <ResponseStatusText>
            <Icon
              style={{
                fill: theme.color.dark.emerald,
                width: '24px',
                height: '24px',
                'margin-right': '8px'
              }}
              type="check-outline"
              size="35px"
            />
            Password Reset Link has been sent to you
          </ResponseStatusText>

          <ResponseStatusInstructions>
            <span className="bold-text">This link is valid only for 1 hour.</span> If you are
            resetting after an hour, request a new link.
            <br /> <br />
            Please check your Spam folder or search for the email with the "
            <a href={'mailto:' + fromEmail} className="mail-link">
              {fromEmail}
            </a>
            " sender address.
          </ResponseStatusInstructions>
        </React.Fragment>
      );
    }

    if (responseStatus === troubleShootUserTypes.USER_INVITATION) {
      return (
        <GreyWrapper>
          <ResponseStatusText>
            <IconWrapper color="#cef5d3">
              <Icon
                style={{ fill: '#2d9d3c', width: '19px', height: '19px' }}
                type="check"
                size="35px"
              />
            </IconWrapper>
            Invitation Email has been sent
          </ResponseStatusText>

          <ResponseStatusInstructions>
            <ul>
              <li>
                Please check your Spam folder or search for the email with the '
                <a href={'mailto:' + fromEmail}>{fromEmail}</a>’ sender address.
              </li>
              <li>To get started, use the temporary password mentioned in the email.</li>
            </ul>
          </ResponseStatusInstructions>
        </GreyWrapper>
      );
    }

    return (
      <div className={troubleLoginEmail}>
        <LoginNormalText className="text-info">
          Please enter your registered email address to request a new email with updated login
          credentials
        </LoginNormalText>
        <form className={troubleLoginForm} onSubmit={this.sendEmail}>
          <DarkBoxInput
            required={true}
            className={inputClass}
            placeholder="Email"
            type="email"
            value={emailAddress}
            onChange={this.onEmailAddressChange}
          />
          <DarkButton className={buttonClass} type="submit" disabled={loading || !emailAddress}>
            {icon}
            {loading ? 'Sending Email' : 'Send email'}
          </DarkButton>
        </form>
      </div>
    );
  };

  render() {
    const { companySubDomain } = this.props;

    return (
      <LoginContent className={content}>
        <LoginContentHeading>Trouble Logging In?</LoginContentHeading>
        <LoginNormalText>{companySubDomain}.lyearn.com</LoginNormalText>
        {this.renderContent()}
        <BackToSignInWrapper>
          <DarkButton.TextButton
            onClick={this.props.backToSignIn}
            style={{ marginRight: '10px', 'font-size': '12px' }}
          >
            &lt;&nbsp;BACK TO SIGN IN
          </DarkButton.TextButton>
        </BackToSignInWrapper>
        <ContactLyearnText>
          Please reach out to us at{' '}
          <a href="mailto:support@lyearn.com" style={{ 'text-decoration': 'none' }}>
            support@lyearn.com
          </a>{' '}
          for further assistance
        </ContactLyearnText>
      </LoginContent>
    );
  }
}

export default DarkTroubleLogin;
